import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import IconQuestion from '@/assets/icons/icon_question.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Wrapper = styled.div(() =>
  mq({
    width: '100%',
  }),
);

export const Section = styled.section(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    margin: [
      `0 auto ${defaultTheme.spacing.s}`,
      `0 auto ${defaultTheme.spacing.s}`,
      `0 auto ${defaultTheme.spacing.l}`,
      `0 auto ${defaultTheme.spacing.l}`,
    ],
    padding: ['24px 16px', '24px 16px', '32px 64px', '32px 64px'],
    width: '100%',
    maxWidth: '840px',
    ':last-of-type': {
      marginBottom: 0,
    },
  }),
);

export const Title = styled.h2(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    fontSize: defaultTheme.font.size.l,
    lineHeight: defaultTheme.font.size.xxl,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
    ],
  }),
);

export const TitleIcon = styled.i((props: { icon: string }) =>
  mq({
    display: 'inline-block',
    width: defaultTheme.font.size.xxl,
    height: defaultTheme.font.size.xxl,
    backgroundImage: `url(${props.icon})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    marginRight: defaultTheme.spacing.xs,
  }),
);

export const Text = styled.p(() =>
  mq({
    fontSize: [
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
    ],
  }),
);

export const ButtonContainer = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: [
      '1fr',
      '1fr',
      'repeat(auto-fit, 320px)',
      'repeat(auto-fit, 320px)',
    ],
    alignContent: 'center',
    justifyContent: 'center',
    gridGap: '16px',
    margin: `${defaultTheme.spacing.xxl} auto`,
    width: ['100%', '100%', '656px', '656px'],
    '& > button:last-of-type': {
      order: [-1, -1, 1],
    },
  }),
);

export const LinkButton = styled(Link)((props: { disabled?: boolean }) =>
  mq({
    pointerEvents: props.disabled ? 'none' : 'unset',
  }),
);

export const GuideLink = styled.a(() =>
  mq({
    display: 'inline-block',
    fontSize: defaultTheme.font.size.s,
    textDecorationLine: 'underline',
    lineHeight: defaultTheme.font.height.base,
    margin: `${defaultTheme.spacing.l} 0 0`,
    ...hoverOpacity,
  }),
);

export const GuideIcon = styled.i(() =>
  mq({
    display: 'inline-block',
    background: `url(${IconQuestion})`,
    marginLeft: defaultTheme.spacing.xs,
    width: '14px',
    height: '14px',
  }),
);

export const Note = styled.p(() =>
  mq({
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.xs,
    lineHeight: defaultTheme.font.height.base,
    marginTop: defaultTheme.spacing.s,
  }),
);

export const CheckWrapper = styled.div(() =>
  mq({
    margin: `${defaultTheme.spacing.xxl} 0`,
  }),
);

export const CheckText = styled.span(() =>
  mq({
    display: 'block',
    fontSize: [
      defaultTheme.font.size.xs,
      defaultTheme.font.size.xs,
      defaultTheme.font.size.s,
    ],
    marginLeft: defaultTheme.spacing.xs,
  }),
);

export const TextLink = styled.span(() =>
  mq({
    textDecorationLine: 'underline',
    lineHeight: defaultTheme.font.height.m,
    ...hoverOpacity,
  }),
);

export const TestSpan = styled.div(() =>
  mq({
    textAlign: 'center',
    '& > span': {
      color: defaultTheme.text.error,
      fontSize: defaultTheme.font.size.m,
      fontWeight: 'bold',
    },
  }),
);
